import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-payors',
  templateUrl: './report-payors.component.html',
  styleUrls: ['./report-payors.component.scss']
})
export class ReportPayorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/manager-reports/report-payors/report-payors.component.ts